import React from 'react';
import {
	TopToolbar,
	CREATE,
	DELETE,
} from 'react-admin';
import IconLock from '@material-ui/icons/Lock';
import IconDelete from '@material-ui/icons/Delete';
import IconInvalidate from '@material-ui/icons/Block';
import IconActivate from '@material-ui/icons/ThumbUpRounded';
import UpdatePaymentInstrument from './UpdatePaymentInstrument';

const PaymentInstrumentShowActions = ({ basePath, data, resource }) => {
	if (data) {
		return (
			<TopToolbar>
				<UpdatePaymentInstrument
					record={data}
					icon={<IconActivate />}
					method="activate"
					dataProviderAction={CREATE}
					disabled={!['Locked', 'Created'].includes(data.paymentInstrumentStatus)}
				/>
				<UpdatePaymentInstrument
					record={data}
					icon={<IconLock />}
					method="lock"
					dataProviderAction={CREATE}
					disabled={['Locked', 'Deleted'].includes(data.paymentInstrumentStatus)}
				/>
				<UpdatePaymentInstrument
					record={data}
					icon={<IconDelete />}
					method="delete"
					dataProviderAction={DELETE}
					disabled={data.paymentInstrumentStatus === 'Deleted'}
				/>
				<UpdatePaymentInstrument
					record={data}
					icon={<IconInvalidate />}
					method="invalidate"
					dataProviderAction={CREATE}
					disabled={!['Created', 'Active', 'Locked'].includes(data.paymentInstrumentStatus)}
				/>
			</TopToolbar>
		);
	} else {
		return null;
	}
};

export default PaymentInstrumentShowActions;
